import { Button } from 'primereact/button';
type HeaderTableProps = {
  enabled: any;
  setEnabled: any;
}
export const HeaderTable = (props:HeaderTableProps) => {
  return (
    <div className="table-header flex justify-between">
      <h5 className="mx-0 my-1">Tabla de precios</h5>
      <div>
        <Button
          icon={props.enabled ? "pi pi-eye" : "pi pi-eye-slash"}
          className="p-button-sm"
          label={props.enabled ? "Ver todas" : "Ocultar dehabilitadas"}
          onClick={() => {props.setEnabled(!props.enabled);}}
        />
      </div>
    </div>
  );
};
